import { storesData } from '../mocks/storesData';
import { generatedScaleoImportReport } from '../data/scaleoImportReport.generated';
import { generatedScaleoStores } from '../data/scaleoStores.generated';

export interface SeedPromo {
  id: string;
  title: string;
  code: string;
  discount: string;
  description: string;
  expiryDate: string;
  isExclusive: boolean;
  partnerUrl: string;
  isActive: boolean;
  createdAt: string;
  isTopDeal: boolean;
  image: string;
}

export interface SeedStore {
  id: string;
  name: string;
  logo: string;
  description: string;
  promocodesCount: number;
  category: string;
  subcategory: string;
  rating: number;
  isPopular: boolean;
  isActive: boolean;
  createdAt: string;
  promos: SeedPromo[];
}

export interface FlatPromocode extends SeedPromo {
  store: string;
  category: string;
  subcategory: string;
  logoUrl: string;
}

const STORE_KEYS = ['admin_stores_v2', 'admin_stores', 'stores'] as const;
const PROMOCODE_KEY = 'promocodes';
const STORE_VERSION_KEY = 'store_seed_version';

export const STORE_SEED_VERSION = generatedScaleoStores.length > 0
  ? generatedScaleoImportReport.generatedAt
  : 'mocks-v2';

const buildDefaultPromos = (createdAt: string): Record<string, SeedPromo[]> => ({
  '1': [
    {
      id: '1',
      title: 'Скидка 500 рублей на первый заказ',
      code: 'WELCOME500',
      discount: '500₽',
      description: 'Получите скидку 500 рублей при первой покупке любого курса или профессии в Skillbox.',
      expiryDate: '2025-12-31',
      isExclusive: true,
      partnerUrl: 'https://skillbox.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
    {
      id: '2',
      title: 'Скидка 15% на годовую подписку',
      code: 'YEAR2025',
      discount: '15%',
      description: 'Оформите годовую подписку на занятия со скидкой 15%. Доступ ко всем урокам, материалам и разговорным клубам на целый год.',
      expiryDate: '2025-12-31',
      isExclusive: false,
      partnerUrl: 'https://skillbox.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
    {
      id: '3',
      title: 'Бесплатный пробный урок',
      code: 'FREETRIAL',
      discount: 'Бесплатно',
      description: 'Запишитесь на бесплатный пробный урок с преподавателем. Определите свой уровень и познакомьтесь с платформой без оплаты.',
      expiryDate: '2025-12-31',
      isExclusive: true,
      partnerUrl: 'https://skillbox.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
  ],
  '2': [
    {
      id: '4',
      title: 'Скидка 500 рублей на первый заказ',
      code: 'WELCOME500',
      discount: '500₽',
      description: 'Получите скидку 500 рублей при первой покупке любого курса английского языка в Skyeng.',
      expiryDate: '2025-12-31',
      isExclusive: true,
      partnerUrl: 'https://skyeng.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
    {
      id: '5',
      title: 'Скидка 15% на годовую подписку',
      code: 'YEAR2025',
      discount: '15%',
      description: 'Оформите годовую подписку на занятия со скидкой 15%. Доступ ко всем урокам, материалам и разговорным клубам на целый год.',
      expiryDate: '2025-12-31',
      isExclusive: false,
      partnerUrl: 'https://skyeng.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
    {
      id: '6',
      title: 'Бесплатный пробный урок',
      code: 'FREETRIAL',
      discount: 'Бесплатно',
      description: 'Запишитесь на бесплатный пробный урок с преподавателем. Определите свой уровень и познакомьтесь с платформой без оплаты.',
      expiryDate: '2025-12-31',
      isExclusive: true,
      partnerUrl: 'https://skyeng.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
  ],
  '3': [
    {
      id: '7',
      title: 'Скидка 500 рублей на первый заказ',
      code: 'WELCOME500',
      discount: '500₽',
      description: 'Получите скидку 500 рублей при первой покупке любого курса или программы обучения в Нетологии.',
      expiryDate: '2025-12-31',
      isExclusive: true,
      partnerUrl: 'https://netology.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
    {
      id: '8',
      title: 'Скидка 15% на годовую подписку',
      code: 'YEAR2025',
      discount: '15%',
      description: 'Оформите годовую подписку со скидкой 15%. Доступ ко всем курсам, вебинарам и материалам на целый год.',
      expiryDate: '2025-12-31',
      isExclusive: false,
      partnerUrl: 'https://netology.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
    {
      id: '9',
      title: 'Бесплатный пробный урок',
      code: 'FREETRIAL',
      discount: 'Бесплатно',
      description: 'Запишитесь на бесплатный пробный урок по любому направлению. Познакомьтесь с форматом обучения и преподавателями.',
      expiryDate: '2025-12-31',
      isExclusive: true,
      partnerUrl: 'https://netology.ru',
      isActive: true,
      createdAt,
      isTopDeal: false,
      image: '',
    },
  ],
});

const getNumericId = (value: string) => (/^\d+$/.test(value) ? Number(value) : null);

export function createSeedStores(): SeedStore[] {
  if (generatedScaleoStores.length > 0) {
    return normalizeStores(generatedScaleoStores).stores;
  }

  const createdAt = new Date().toISOString();
  const defaultPromos = buildDefaultPromos(createdAt);

  const seededStores = storesData.map((store) => {
    const id = String(store.id);
    const promos = defaultPromos[id] ?? [];

    return {
      id,
      name: store.name,
      logo: store.logo,
      description: store.description,
      promocodesCount: promos.filter((promo) => promo.isActive).length,
      category: store.category,
      subcategory: store.subcategory ?? '',
      rating: store.rating,
      isPopular: store.isPopular,
      isActive: true,
      createdAt,
      promos,
    };
  });

  return normalizeStores(seededStores).stores;
}

export function normalizeStores(stores: SeedStore[]): { stores: SeedStore[]; changed: boolean } {
  let changed = false;
  const fingerprintSet = new Set<string>();
  const dedupedStores: SeedStore[] = [];

  for (const store of stores) {
    const fingerprint = `${store.id}::${store.name}::${store.category}`;
    if (fingerprintSet.has(fingerprint)) {
      changed = true;
      continue;
    }

    fingerprintSet.add(fingerprint);
    dedupedStores.push(store);
  }

  const maxStoreId = dedupedStores.reduce((maxId, store) => {
    const numericId = getNumericId(store.id);
    return numericId === null ? maxId : Math.max(maxId, numericId);
  }, 0);
  const maxPromoId = dedupedStores.reduce((maxId, store) => {
    return Math.max(
      maxId,
      ...(store.promos ?? []).map((promo) => getNumericId(promo.id) ?? 0),
    );
  }, 0);

  let nextStoreId = maxStoreId + 1;
  let nextPromoId = maxPromoId + 1;
  const usedStoreIds = new Set<string>();
  const usedPromoIds = new Set<string>();

  const normalizedStores = dedupedStores.map((store) => {
    let storeId = store.id;
    if (!storeId || usedStoreIds.has(storeId)) {
      storeId = String(nextStoreId++);
      changed = true;
    }
    usedStoreIds.add(storeId);

    const normalizedPromos = (store.promos ?? []).map((promo) => {
      let promoId = promo.id;
      if (!promoId || usedPromoIds.has(promoId) || getNumericId(promoId) === null) {
        promoId = String(nextPromoId++);
        changed = true;
      }
      usedPromoIds.add(promoId);

      if (promo.id === promoId) {
        return promo;
      }

      return {
        ...promo,
        id: promoId,
      };
    });

    const promocodesCount = normalizedPromos.filter((promo) => promo.isActive).length;
    if (
      store.id !== storeId ||
      store.promocodesCount !== promocodesCount ||
      (store.promos ?? []).length !== normalizedPromos.length
    ) {
      changed = true;
    }

    return {
      ...store,
      id: storeId,
      promocodesCount,
      promos: normalizedPromos,
    };
  });

  return {
    stores: normalizedStores,
    changed,
  };
}

export function flattenPromocodes(stores: SeedStore[]): FlatPromocode[] {
  return stores.flatMap((store) =>
    (store.promos ?? []).map((promo) => ({
      ...promo,
      store: store.name,
      category: store.category,
      subcategory: store.subcategory,
      logoUrl: store.logo,
    })),
  );
}

export function readPersistedStores(storage: Storage = localStorage): SeedStore[] {
  for (const key of STORE_KEYS) {
    const rawStores = storage.getItem(key);
    if (!rawStores) {
      continue;
    }

    try {
      const parsedStores = JSON.parse(rawStores) as SeedStore[];
      if (Array.isArray(parsedStores)) {
        return parsedStores;
      }
    } catch {
      continue;
    }
  }

  return [];
}

export function syncStoresToStorage(stores: SeedStore[], storage: Storage = localStorage): SeedStore[] {
  const normalizedStores = normalizeStores(stores).stores;
  const promocodes = flattenPromocodes(normalizedStores);

  for (const key of STORE_KEYS) {
    storage.setItem(key, JSON.stringify(normalizedStores));
  }
  storage.setItem(PROMOCODE_KEY, JSON.stringify(promocodes));
  storage.setItem(STORE_VERSION_KEY, STORE_SEED_VERSION);

  return normalizedStores;
}

export function ensureStoreSeedData(storage: Storage = localStorage): SeedStore[] {
  if (typeof window === 'undefined') {
    return [];
  }

  const persistedStores = readPersistedStores(storage);
  const persistedVersion = storage.getItem(STORE_VERSION_KEY);

  if (!persistedStores.length || persistedVersion !== STORE_SEED_VERSION) {
    return syncStoresToStorage(createSeedStores(), storage);
  }

  try {
    return syncStoresToStorage(persistedStores, storage);
  } catch {
    return syncStoresToStorage(createSeedStores(), storage);
  }
}
